import { Route as PurchaseReturnsRoute } from "@/routes/(pharma)/_layout/reports/purchase-returns-list/index";
import { useQuery } from "@tanstack/react-query";
import { getPurchaseReturns } from "../-data/api";

interface PurchaseReturnsQueryResult {
  purchaseReturns: any[];
  totalCount: number;
}

export const usePurchaseReturnsData = () => {
  const searchParams = PurchaseReturnsRoute.useSearch();
  
  return useQuery<PurchaseReturnsQueryResult>({
    queryKey: ["purchase-returns", searchParams],
    queryFn: async () => {
      return await getPurchaseReturns(
        searchParams.page || 1,
        searchParams.pageSize || 10,
        searchParams.supplierId
      );
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};